import React from 'react';
import { T } from '../../lib/tokens';

interface WordmarkProps {
  size?: number;
  color?: string;
  accent?: string;
  style?: React.CSSProperties;
}

export const Wordmark: React.FC<WordmarkProps> = ({
  size = 20,
  color = T.cream,
  accent = T.sage,
  style,
}) => (
  <span
    style={{
      fontFamily: "'Geist', sans-serif",
      fontWeight: 600,
      letterSpacing: '-0.022em',
      fontSize: size,
      color,
      lineHeight: 1,
      ...style,
    }}
  >
    receipt<span style={{ color: accent }}>{`rec`}</span>
  </span>
);
